import {getApiUrl} from "./client";

export type HotspotHabitatFeedbackModerationAction = 'reviewed' | 'applied' | 'dismissed';

export type HotspotHabitatFeedbackModerationSubmission = {
    action: HotspotHabitatFeedbackModerationAction;
    feedbackIds: number[];
    locationId?: string;
    hotspotName?: string;
    overrideHabitat?: string;
    overrideFamily?: string;
    overrideDisplayHabitat?: string;
    overrideBaseHabitat?: string;
    reason?: string;
    evidenceSummary?: Record<string, unknown>;
};

export type HotspotHabitatFeedbackModerationResponse = {
    status: string;
    result: {
        action: HotspotHabitatFeedbackModerationAction;
        feedbackIds: number[];
        status: string;
        override?: Record<string, unknown> | null;
    };
};

export const moderateHotspotHabitatFeedback = async (submission: HotspotHabitatFeedbackModerationSubmission) => {
    const response = await fetch(getApiUrl('/api/admin/hotspots/habitat-feedback/moderate'), {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(submission)
    });

    if (!response.ok) {
        let message = `Habitat moderation failed with ${response.status}`;

        try {
            const payload = await response.json();
            if (payload?.message) {
                message = payload.message;
            }
        } catch (error) {
            // Ignore parse errors and surface the HTTP status instead.
        }

        throw new Error(message);
    }

    return await response.json() as HotspotHabitatFeedbackModerationResponse;
};
